/* ONAIR V3: scoped disclosure behavior. No product-price or cart interception. */
(function(){
 'use strict';
 var allowedIds=['onair-v3-kit-included','onair-management-comparison'];
 function ready(){
  document.querySelectorAll('details.o3-included, details#onair-management-comparison').forEach(function(panel){
   var summary=panel.querySelector(':scope > summary');
   if(!summary||summary.dataset.o3DisclosureReady==='true')return;
   summary.dataset.o3DisclosureReady='true';
   function reflect(){summary.setAttribute('aria-expanded',String(panel.open));}
   summary.addEventListener('click',function(event){
    /* Prevent inherited summary handlers from cancelling or duplicating this toggle. */
    event.preventDefault();
    event.stopImmediatePropagation();
    panel.open=!panel.open;
    reflect();
   },true);
   panel.addEventListener('toggle',reflect);
   reflect();
  });
  openHashDisclosure();
 }
 function openHashDisclosure(){
  var id=location.hash.slice(1);
  if(allowedIds.indexOf(id)===-1)return;
  var panel=document.getElementById(id);
  if(!panel)return;
  panel.open=true;
  requestAnimationFrame(function(){panel.scrollIntoView({block:'start',behavior:'auto'});});
 }
 document.addEventListener('click',function(event){
  var target=event.target;
  var link=target&&target.closest?target.closest('a[href="#onair-v3-kit-included"],a[href="#onair-management-comparison"]'):null;
  if(!link)return;
  var panel=document.getElementById(link.getAttribute('href').slice(1));
  if(panel)panel.open=true;
 });
 window.addEventListener('hashchange',openHashDisclosure);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready,{once:true});else ready();
 document.addEventListener('shopify:section:load',ready);
})();
